// F1 — רב-לשוניות. מקור-אמת יחיד לרשימת השפות הנתמכות.
//
// ★★ הקובץ הזה מיובא גם מקוד שאינו React (redux actions, utils) וגם מ-App.js,
//    ולכן הוא חייב להישאר נטול-תלות ב-react/redux. אל תוסיפו כאן import כבד.
//
// `dir` הוא המאפיין היחיד שקובע RTL/LTR בכל המערכת — הכיווניות נגזרת מהשפה
// ולא נכתבת ידנית באף מקום אחר (ראה applyDocumentLang ב-index.js).

export const DEFAULT_LANG = 'he';

// הסדר כאן הוא הסדר שבו השפות מוצגות בבורר (נקבע ע"י המשתמש, 27/07):
// עברית · אנגלית · ערבית · רוסית · אמהרית.
export const LANGS = [
  { code: 'he', dir: 'rtl', label: 'עברית',    nativeLabel: 'עברית',   dayjs: 'he', muiLocale: 'heIL' },
  { code: 'en', dir: 'ltr', label: 'אנגלית',   nativeLabel: 'English', dayjs: 'en', muiLocale: 'enUS' },
  { code: 'ar', dir: 'rtl', label: 'ערבית',    nativeLabel: 'العربية', dayjs: 'ar', muiLocale: 'arEG' },
  { code: 'ru', dir: 'ltr', label: 'רוסית',    nativeLabel: 'Русский', dayjs: 'ru', muiLocale: 'ruRU' },
  // ★ אמהרית — LTR, כתב געז. ‏`dayjs/locale/am` ו-`amET` של MUI קיימים
  //   בגרסאות המותקנות (נבדק), ולכן אין צורך ב-fallback.
  { code: 'am', dir: 'ltr', label: 'אמהרית',   nativeLabel: 'አማርኛ',   dayjs: 'am', muiLocale: 'amET' },
];

export const LANG_CODES = LANGS.map((l) => l.code);

/** @returns {{code:string,dir:string,label:string,nativeLabel:string,dayjs:string,muiLocale:string}} */
export function langMeta(code) {
  return LANGS.find((l) => l.code === code) || LANGS[0];
}

export function isSupported(code) {
  return typeof code === 'string' && LANG_CODES.indexOf(code) !== -1;
}

export function dirOf(code) {
  return langMeta(code).dir;
}
